import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useCreateHostValidationSchema = () => {
  const { t } = useTranslation(['hosts']);

  return z.object({
    email: z
      .string()
      .email(t('hosts:dialogs.invite.validation.email'))
      .min(1, t('hosts:dialogs.invite.validation.required')),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    phoneNumber: z.string().optional(),
  });
};
